import progress from './progress';
import role from './role';
import user from './user';
import chat from './chat';
import business from './business';
import places from './places';
import verification from './verification';
import auth from './auth';
import financials from './financials';
import organization from './organization';
import usage from './usage';
import businessClaim from './businessClaim';
import billing from './billing';
import loanBeacon from './loanBeacon';

export default {
  chat,
  user,
  role,
  progress,
  business,
  places,
  verification,
  auth,
  financials,
  organization,
  usage,
  businessClaim,
  billing,
  loanBeacon,
}